import { render, staticRenderFns } from "./MultiSelectArea.vue?vue&type=template&id=12d6bfb2&"
import script from "./MultiSelectArea.vue?vue&type=script&lang=js&"
export * from "./MultiSelectArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports